import * as React from 'react';

export const Document = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 22 22" {...props}>
    <path
      fill="currentColor"
      d="M18.785 6.185l-5.07-5.07A2.1 2.1 0 0 0 12.23.5H4.7a2.1 2.1 0 0 0-2.1 2.1v16.8c0 1.16.94 2.1 2.1 2.1h12.6a2.1 2.1 0 0 0 2.1-2.1V7.67a2.1 2.1 0 0 0-.615-1.485zM13.1 7.85c-.58 0-1.05-.47-1.05-1.05V2.075l5.775 5.775H13.1z"
    />
  </svg>
);
